import actionTypes from '../actionTypes/actionTypes';

const DEFAULT_PREVIEW = false
const DEFAULT_PAGE_SELECTION = true
const DEFAULT_NAVIGATION = true
const DEFAULT_DETAILS = true
const DEFAULT_CONTEXT_MENU = false
const DEFAULT_ICON_HOVER = false

export const initialState = {
  resize: {},
  iconHover: DEFAULT_ICON_HOVER,
  preview: DEFAULT_PREVIEW,
  details: DEFAULT_DETAILS
}

function navigationReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESIZE: /* RESIZE */
    	return Object.assign({}, state, { resize: action.data })
    	break
    case actionTypes.CHANGE_ICON_HOVER: /* ICON HOVER */
    	return Object.assign({}, state, { iconHover: action.data })
    	break    
  	case actionTypes.CHANGE_DETAILS: /* DETAILS */
  		return Object.assign({}, state, { details: action.data.details })
  		break
  	case actionTypes.CHANGE_PREVIEW: /* PREVIEW */
  		return Object.assign({}, state, { preview: action.data.preview })
  		break
    default: /* DEFAULT */
      return state
  }
}

export default navigationReducer;